<!-- heating.burners.0 -->
<!-- TODO VIG-3076 commented temporarily
  After uncommenting, please replace the input with this one
  [isMoreActions]="(emergencyMode$ | async | ready) || (defrosting$ | async | ready)"
-->

<app-features-container
  [header]="'+INSTALLATIONS.INSTALLATION.PANEL.BOILER' | translate"
  [overlayType]="availableOverlays.System"
  [isMoreActions]="!!(emergencyMode$ | async | ready)"
>
  <div header class="flex system-header flex-row gap-[4px]">
    <ng-container *ngIf="isMultiFamily$ | async | ready as feature">
      <app-pill
        class="flex flex-row justify-center items-center"
        *ngIf="feature.properties?.active?.value === true"
        title
        [type]="pillType.success"
        [attr.data-feature]="feature.feature"
      >
        {{ '+INSTALLATIONS.INSTALLATION.BOILER.MULTI_FAMILY_CHIP' | translate }}
      </app-pill>
    </ng-container>

    <ng-container *ngIf="emergencyMode$ | async | ready as feature">
      <app-pill
        *ngIf="feature.properties?.active?.value === true"
        class="flex flex-row justify-center items-center"
        title
        data-at-emergency-mode-chip
        [type]="pillType.medium"
        [attr.data-feature]="feature.feature"
      >
        {{ '+INSTALLATIONS.INSTALLATION.BOILER.EMERGENCY_MODE_ACTIVE_CHIP' | translate }}
      </app-pill>
    </ng-container>

    <ng-container *ngIf="comfortEnsuringMode$ | async | ready as feature">
      <app-pill
        *ngIf="feature.properties?.activated?.value === true"
        class="flex flex-row justify-center items-center"
        title
        data-at-comfort-ensuring-mode-chip
        [type]="pillType.success"
        [attr.data-feature]="feature.feature"
      >
        {{ '+INSTALLATIONS.INSTALLATION.BOILER.COMFORT_ENSURING_MODE_ACTIVE_CHIP' | translate }}
      </app-pill>
    </ng-container>
    <ng-container *ngIf="powerLimitationLabel$ | async as labels">
      <app-pill
        *ngFor="let label of labels"
        class="flex limitation-labels flex-row justify-center items-center mr-2"
        [type]="pillType.primary"
        [matTooltip]="
          label.isConsumption
            | booleanSuffix
              : [
                  '+INSTALLATIONS.INSTALLATION.POWER_LIMITATION.TOOLTIP.GRID_CONSUMPTION_LIMIT',
                  '+INSTALLATIONS.INSTALLATION.POWER_LIMITATION.TOOLTIP.PV_FEED_IN_LIMIT'
                ]
            | translate
              : {
                  value: label | featureLike | value2: featurePropertyKey.value,
                  unit: label | featureLike | unit: featurePropertyKey.value
                }
        "
      >
        {{ label.label | translate }}
      </app-pill>
    </ng-container>
  </div>

  <ng-container feature *ngIf="devicesStore.isEcotronicDevice$ | async; else otherDevices">
    <!-- heating.device.status -->
    <app-feature-tile
      *ngIf="heatingDeviceStatus$ | async | ready as feature"
      data-at-device-status
      label="{{ '+INSTALLATIONS.INSTALLATION.SYSTEM_DETAILS.ECOTRONIC.STATUS' | translate }}"
      [value]="feature.properties?.value?.value | translateHeatingDeviceStatus"
      [attr.data-feature]="feature.feature"
    >
    </app-feature-tile>

    <!-- heating.solar.status -->
    <app-feature-tile
      *ngIf="solarStatus$ | async | ready as feature"
      data-at-solar-status
      label="{{ '+INSTALLATIONS.INSTALLATION.SYSTEM_DETAILS.ECOTRONIC.SOLAR_STATUS' | translate }}"
      [value]="feature.properties?.value?.value | translateHeatingSolarStatus"
      [attr.data-feature]="feature.feature"
    >
    </app-feature-tile>

    <!-- heating.device.fuel.current -->
    <app-feature-tile
      *ngIf="heatingDeviceFuelCurrent$ | async | ready as feature"
      data-at-current-fuel-tank-value
      label="{{
        '+INSTALLATIONS.INSTALLATION.SYSTEM_DETAILS.ECOTRONIC.CURRENT_FUEL_TANK_CAPACITY'
          | translate
      }}"
      value="{{ feature | value2: featurePropertyKey.value }} {{
        feature | unit: featurePropertyKey.value
      }} ({{ fuelVolume$ | async }} %)"
      [attr.data-feature]="feature.feature"
    >
    </app-feature-tile>

    <!-- heating.boiler.ash.level.current -->
    <app-feature-tile
      *ngIf="heatingBoilerAshLevel$ | async | ready as feature"
      data-at-boiler-ash-level
      label="{{ '+INSTALLATIONS.INSTALLATION.BOILER.ASH_LEVEL_CURRENT' | translate }}"
      value="{{ feature | value2: featurePropertyKey.value }} {{
        feature | unit: featurePropertyKey.value
      }}"
      [attr.data-feature]="feature.feature"
    >
    </app-feature-tile>
  </ng-container>

  <ng-template feature #otherDevices>
    <!-- heating.calculated.temperature.outside  -->
    <app-feature-tile
      *ngIf="calculatedOutsideTemperature$ | async | ready as feature"
      data-at-calculated-outside-temperature
      label="{{ '+INSTALLATIONS.INSTALLATION.CALCULATED_OUTSIDE_TEMPERATURE' | translate }}"
      value="{{ feature | value2: featurePropertyKey.value }} {{
        feature | unit: featurePropertyKey.value
      }}"
      [error]="feature | error"
    ></app-feature-tile>

    <!-- heating.burners.0 -->
    <app-feature-tile
      *ngIf="burner$ | async | ready as feature"
      label="{{ '+INSTALLATIONS.INSTALLATION.BOILER.BURNER' | translate }}"
      [value]="
        feature.properties?.active?.value
          | booleanSuffix
            : [
                customTranslationsService.STATE.on | translate,
                customTranslationsService.STATE.off | translate
              ]
      "
      [attr.data-feature]="feature.feature"
    ></app-feature-tile>

    <!-- heating.burners.0.modulation -->
    <app-feature-tile
      *ngIf="modulation$ | async | ready as feature"
      label="{{ '+INSTALLATIONS.INSTALLATION.BOILER.BURNER_MODULATION' | translate }}"
      value="{{ feature | value2: featurePropertyKey.value }} {{
        feature | unit: featurePropertyKey.value
      }}"
      [attr.data-feature]="feature.feature"
    ></app-feature-tile>

    <!-- ess.sensors.temperature.ambient	 -->
    <app-feature-tile
      data-at-ess-temperature-ambient
      *ngIf="ambientTemperature$ | async | ready as feature"
      [error]="feature | error"
      [label]="'+INSTALLATIONS.INSTALLATION.VITOCHARGE.ESS.AMBIENT_TEMPERATURE' | translate"
      value="{{ feature | value2: featurePropertyKey.value }} {{
        feature | unit: featurePropertyKey.value
      }}"
      [attr.data-feature]="feature.feature"
    ></app-feature-tile>
    <!-- ess.configuration.systemType	 -->
    <app-feature-tile
      data-at-ess-system-type
      *ngIf="essSystemType$ | async | ready as feature"
      [error]="feature | error"
      [label]="'+INSTALLATIONS.INSTALLATION.ESS_SYSTEM_TYPE.TITLE' | translate"
      [value]="feature | value2: featurePropertyKey.value | translateEssSystemType"
      [attr.data-feature]="feature.feature"
    ></app-feature-tile>
    <!-- ess.inverter.ac.power.consolidated for cascade device -->
    <app-feature-tile
      data-at-inverter-power
      *ngIf="
        (devicesStore.shouldUseConsolidatedFeature$ | async) &&
          (inverterPowerConsolidatedFeatures$ | async | ready) &&
          (inverterPowerConsolidatedPerDevice$ | async) as feature;
        else inverterPower
      "
      [label]="'+INSTALLATIONS.INSTALLATION.VITOCHARGE.PHOTOVOLTAICS.INVERTER_POWER' | translate"
      value="{{ feature | featureLike | value2: featurePropertyKey.value }} {{
        feature | featureLike | unit: featurePropertyKey.value
      }}"
    ></app-feature-tile>
    <!-- ess.inverter.ac.power for single device -->
    <ng-template #inverterPower>
      <app-feature-tile
        data-at-inverter-power
        *ngIf="inverterPower$ | async | ready as feature"
        [error]="feature | error"
        [label]="'+INSTALLATIONS.INSTALLATION.VITOCHARGE.PHOTOVOLTAICS.INVERTER_POWER' | translate"
        value="{{ feature | value2: featurePropertyKey.activePower }} {{
          feature | unit: featurePropertyKey.activePower
        }}"
        [attr.data-feature]="feature.feature"
      ></app-feature-tile>
    </ng-template>
    <!-- Power Grid connection point -->
    <app-feature-tile
      data-at-power-grid-connection-point
      *ngIf="powerGridConnectionPoint$ | async | ready as feature"
      [error]="feature | error"
      [label]="
        feature.properties?.value.value > 0
          ? ('+INSTALLATIONS.INSTALLATION.VITOCHARGE.POWER_GRID.GRID_CONSUMPTION' | translate)
          : ('+INSTALLATIONS.INSTALLATION.VITOCHARGE.POWER_GRID.CONNECTION_POINT' | translate)
      "
      value="{{ feature | value2: featurePropertyKey.value | absoluteValue }} {{
        feature | unit: featurePropertyKey.value
      }}"
      [attr.data-feature]="feature.feature"
    ></app-feature-tile>

    <!-- heating.boiler.sensors.temperature.main -->
    <app-feature-tile
      *ngIf="boilerTemperature$ | async | ready as feature"
      label="{{ '+INSTALLATIONS.INSTALLATION.BOILER.BOILER_TEMPERATURE' | translate }}"
      value="{{ feature | value2: featurePropertyKey.value }} {{
        feature | unit: featurePropertyKey.value
      }}"
      [attr.data-feature]="feature.feature"
      [error]="feature | error"
    >
    </app-feature-tile>

    <!-- heating.cascade.temperature.commonSupply -->
    <!-- if not lead device then -->
    <!-- heating.boiler.sensors.temperature.commonSupply -->
    <ng-template
      [ngIf]="(devicesStore.selectedDevice$ | async)?.isLeadDeviceInCascades"
      [ngIfElse]="commonFlowTemperature"
    >
      <app-feature-tile
        *ngIf="leadDeviceCommonSupply$ | async | ready as feature"
        label="{{ '+INSTALLATIONS.INSTALLATION.BOILER.COMMON_FLOW_TEMPERATURE' | translate }}"
        value="{{ feature | value2: featurePropertyKey.value }} {{
          feature | unit: featurePropertyKey.value
        }}"
        [attr.data-feature]="feature.feature"
        [error]="feature | error"
      >
      </app-feature-tile>
    </ng-template>

    <ng-template #commonFlowTemperature feature>
      <app-feature-tile
        *ngIf="commonFlowTemperature$ | async | ready as feature"
        label="{{ '+INSTALLATIONS.INSTALLATION.BOILER.COMMON_FLOW_TEMPERATURE' | translate }}"
        value="{{ feature | value2: featurePropertyKey.value }} {{
          feature | unit: featurePropertyKey.value
        }}"
        [attr.data-feature]="feature.feature"
        [error]="feature | error"
      >
      </app-feature-tile>
    </ng-template>

    <!-- heating.sensors.temperature.outside -->
    <app-feature-tile
      *ngIf="outsideTemperature$ | async | ready as feature"
      label="{{ '+INSTALLATIONS.INSTALLATION.BOILER.OUTSIDE_TEMPERATURE' | translate }}"
      value="{{ feature | value2: featurePropertyKey.value }} {{
        feature | unit: featurePropertyKey.value
      }}"
      [attr.data-feature]="feature.feature"
      [error]="feature | error"
    >
    </app-feature-tile>

    <app-feature-tile
      *ngIf="ventilationFanExhaust$ | async | ready as feature"
      label="{{ '+INSTALLATIONS.INSTALLATION.VENTILATION.EXHAUST_FAN' | translate }}"
      value="{{ feature | value2: featurePropertyKey.current }} {{
        feature | sensorStatusConnected | unit: featurePropertyKey.current
      }}"
      [attr.data-feature]="feature.feature"
      [error]="feature | error"
    >
    </app-feature-tile>

    <app-feature-tile
      *ngIf="ventilationFanSupply$ | async | ready as feature"
      label="{{ '+INSTALLATIONS.INSTALLATION.VENTILATION.SUPPLY_FAN' | translate }}"
      value="{{ feature | value2: featurePropertyKey.current }} {{
        feature | sensorStatusConnected | unit: featurePropertyKey.current
      }}"
      [attr.data-feature]="feature.feature"
      [error]="feature | error"
    >
    </app-feature-tile>

    <app-feature-tile
      *ngIf="ventilationHeatRecovery$ | async | ready as feature"
      label="{{ '+INSTALLATIONS.INSTALLATION.VENTILATION.HEAT_RECOVERY' | translate }}"
      value="{{ feature | value2: featurePropertyKey.value }} {{
        feature | unit: featurePropertyKey.value
      }}"
      [attr.data-feature]="feature.feature"
    >
    </app-feature-tile>

    <ng-container
      *ngIf="
        (devicesStore.isVitovalorPA2Device$ | async) && devicesStore.selectedDevice$
          | async as device
      "
    >
      <!-- device status -->
      <app-feature-tile
        *ngIf="device.status"
        label="{{ '+INSTALLATIONS.INSTALLATION.STATUS.TITLE' | translate }}"
        [value]="device.status | translateDeviceStatus"
        [attr.data-feature]="'device.status'"
      >
      </app-feature-tile>

      <!-- device last status changed date -->
      <app-feature-tile
        *ngIf="device.editedAt"
        label="{{ '+INSTALLATIONS.INSTALLATION.LAST_STATUS_CHANGED' | translate }}"
        [value]="device.editedAt | date: 'short'"
        [attr.data-feature]="'device.LastStatusChange'"
      >
      </app-feature-tile>
    </ng-container>

    <app-feature-tile
      *ngIf="devicesStore.heatPumpSmartGrid$ | async | ready as smartGridValue"
      feature
      [label]="'+INSTALLATIONS.INSTALLATION.HEAT_PUMP.SMART_GRID_STATE.TITLE' | translate"
      [value]="
        '+INSTALLATIONS.INSTALLATION.HEAT_PUMP.SMART_GRID.VALUES.' + smartGridValue.toUpperCase()
          | translate
          | unknownModeDash
      "
      data-at-smart-grid-value
      data-feature="heating.device.smartGrid"
    ></app-feature-tile>
  </ng-template>

  <!-- TODO VIG-3076 commented temporarily
    After uncommenting, please replace the condition with this one
    *ngIf="(emergencyMode$ | async) || (defrosting$ | async | ready)" -->
  <ng-container *ngIf="emergencyMode$ | async" more-menu>
    <button
      *ngIf="emergencyMode$ | async | ready as emergencyMode"
      data-at-access-list
      mat-menu-item
      gtm="onOpen"
      gtmAction="Emergency mode"
      gtmCategory="system"
      [disabled]="emergencyMode?.properties?.active?.value === true"
      [viConfirm]="{
        title: '+INSTALLATIONS.INSTALLATION.BOILER.EMERGENCY_MODE_CONFIRM_TITLE' | translate,
        content: '+INSTALLATIONS.INSTALLATION.BOILER.EMERGENCY_MODE_CONFIRM_CONTENT' | translate,
        cancelBtn: 'GENERAL.BUTTON.CANCEL' | translate,
        confirmBtn: 'GENERAL.BUTTON.ACCEPT' | translate
      }"
      (confirm)="activateEmergencyMode()"
      (cancel)="cancelEmergencyModeConfirmation()"
    >
      {{ '+INSTALLATIONS.INSTALLATION.BOILER.EMERGENCY_MODE' | translate }}
    </button>
    <!-- TODO VIG-3076 commented temporarily -->
    <!-- <ng-container *ngIf="defrosting$ | async | ready as feature">
      <button
        *ngIf="!feature.properties?.active?.value"
        mat-menu-item
        class="start-defrosting-btn flex flex-row justify-start items-center"
        data-at-start-defrosting-btn
        gtm="onOpen"
        gtmAction="Defrosting"
        gtmCategory="system"
        [disabled]="
          feature.properties?.active?.value
            ? !(feature | executable: 'deactivate')
            : !(feature | executable: 'activate')
        "
        [viConfirm]="{
          title: '+INSTALLATIONS.INSTALLATION.HEATPUMP.START_DEFROSTING_DIALOG.TITLE' | translate,
          content:
            '+INSTALLATIONS.INSTALLATION.HEATPUMP.START_DEFROSTING_DIALOG.MESSAGE' | translate,
          cancelBtn: 'GENERAL.BUTTON.CANCEL' | translate,
          confirmBtn: 'GENERAL.BUTTON.CONFIRM' | translate
        }"
        (confirm)="
          installationService.onDefrostingProcessChange(true);
          gtmService.track('onConfirm', 'Start defrosting', 'system')
        "
        (cancel)="gtmService.track('onCancel', 'Start defrosting confirmation', 'system')"
      >
        <vi-icon icon name="defrosting" size="24"></vi-icon>
        <span>{{
          '+INSTALLATIONS.INSTALLATION.HEATPUMP.START_DEFROSTING.BUTTON' | translate
        }}</span>
      </button>
      <button
        *ngIf="feature.properties?.active?.value"
        mat-menu-item
        class="stop-defrosting-btn flex flex-row justify-start items-center"
        data-at-stop-defrosting-btn
        gtm="onOpen"
        gtmAction="Defrosting"
        gtmCategory="system"
        [disabled]="
          feature.properties?.active?.value
            ? !(feature | executable: 'deactivate')
            : !(feature | executable: 'activate')
        "
        [viConfirm]="{
          title: '+INSTALLATIONS.INSTALLATION.HEATPUMP.STOP_DEFROSTING_DIALOG.TITLE' | translate,
          content:
            '+INSTALLATIONS.INSTALLATION.HEATPUMP.STOP_DEFROSTING_DIALOG.MESSAGE' | translate,
          cancelBtn: 'GENERAL.BUTTON.CANCEL' | translate,
          confirmBtn: 'GENERAL.BUTTON.CONFIRM' | translate
        }"
        (confirm)="
          installationService.onDefrostingProcessChange(false);
          gtmService.track('onConfirm', 'Stop defrosting', 'system')
        "
        (cancel)="gtmService.track('onCancel', 'Stop defrosting confirmation', 'system')"
      >
        <mat-spinner></mat-spinner>
        <span>{{ '+INSTALLATIONS.INSTALLATION.HEATPUMP.STOP_DEFROSTING.BUTTON' | translate }}</span>
      </button>
    </ng-container> -->
  </ng-container>
</app-features-container>
